import { ProgressButtonComponent } from "@syncfusion/ej2-react-splitbuttons";
import React from "react";
import { Button } from "react-bootstrap";
import { CANCELLED_STATUS, CANCELLED_NOT_ELIGIBLE_STATUS, DROPPED_OFF, DROPPED_OFF_STATUS } from "../../app/utils/Constants";
const TimedDrawFooter = (props) => {

	const { mode, updateTimedDraw, status, editOrder, saveChanges, originalStatus, originalStatusText, notify, handleSubmit, cancelModal, isFormChanged, disableSave = false} = props;
	return (
		<React.Fragment>
			<Button
				data-testid="button-cancel"
				className="primary-btn primary-btn-outline outline"
				onClick={cancelModal}
			>
				Cancel
			</Button>
			{mode === "view" ? (
				updateTimedDraw &&
				status !== CANCELLED_STATUS &&
				status !== CANCELLED_NOT_ELIGIBLE_STATUS && (
					<Button
						data-testid="time-draw-button-view"
						className="primary-btn primary-btn-outline outline"
						onClick={editOrder}
					>
						Edit Timed Draw
					</Button>
				)
			) : (
				<ProgressButtonComponent
					data-testid="time-draw-button-submit"
					content={mode === "edit" ? "Save Changes" : "Create Order"}
					enableProgress={true}
					spinSettings={{ position: "Center" }}
					animationSettings={{ effect: "SlideLeft" }}
					cssClass="primary-btn primary-btn-outline ad-progress-btn"
					onClick={() => saveChanges()}
					disabled={mode === "edit" ? (!isFormChanged || disableSave) : disableSave}
				></ProgressButtonComponent>
			)}
			{mode === "view" && originalStatus == DROPPED_OFF_STATUS && originalStatusText === DROPPED_OFF && notify && (
				<ProgressButtonComponent
					data-testid="time-draw-button-submit-with-notify"
					content={"Save Changes"}
					enableProgress={true}
					spinSettings={{ position: "Center" }}
					animationSettings={{ effect: "SlideLeft" }}
					cssClass="primary-btn primary-btn-outline ad-progress-btn"
					onClick={() => handleSubmit()}
				></ProgressButtonComponent>
			)}
		</React.Fragment>
	);
}

export default TimedDrawFooter;
